import { attributesToProps } from 'html-react-parser';
import { Image } from '@/app_components/common/Image';
import type { ParserProps } from '@/app_lib/htmlParser/types';
import { cn } from '@/app_lib/utils/utils';

export const ImageParser = ({ domNode }: ParserProps) => {
  const { attribs } = domNode;
  const props = attributesToProps(attribs);
  const { src, className, alt, width, height } = props;
  const dataSrc = attribs['data-src'];

  if (!(src || dataSrc)) {
    return null;
  }

  const widthNum = width ? Number(width) : 1024;
  const heightNum = height ? Number(height) : 683;

  return (
    <Image
      alt={alt?.toString() || ''}
      className={cn(className, 'not-prose w-full', !(widthNum && heightNum) && 'object-cover')}
      height={heightNum}
      loading='lazy'
      pictureClassName='w-full'
      src={dataSrc?.toString() || src.toString()}
      width={widthNum}
    />
  );
};
